import { useRef, useSyncExternalStore } from 'react';

export const useStoreSelector = (store, selector, isEqual = Object.is) => {
  const hasSelectionRef = useRef(false);
  const selectionRef = useRef();

  const getSelection = () => {
    const nextSelection = selector(store.getState());
    if (hasSelectionRef.current && isEqual(selectionRef.current, nextSelection)) {
      return selectionRef.current;
    }
    hasSelectionRef.current = true;
    selectionRef.current = nextSelection;
    return nextSelection;
  };

  return useSyncExternalStore(store.subscribe, getSelection, getSelection);
};
